<template>
  <a-select
      ref="select"
      :value="selectVal"
      style="width: 100%"
      @change="handleChange"
      showSearch
      optionFilterProp="name"
      :disabled="disabled"
  >
    <a-select-option v-for="item in list" :value="item[optionValue]" :key="item[optionValue]" :name="item[optionText]">
      {{
        item[optionText]
      }}
    </a-select-option>
  </a-select>
</template>

<script>

export default {
  name: "selectIdAndName",
  props: {
    list: Array,
    optionValue: String,
    optionText: String,
    value: String,
    disabled : Boolean
  },
  emits: ['update:value'],
  data() {
    return {
      selectVal: ""
    }
  },
  mounted() {
    this.selectVal = this.value
  },
  methods: {
    handleChange(value) {
      this.selectVal = value
      this.$emit("update:value", value)
    },
  },
  watch:{
    value(){
      this.selectVal = this.value;
    }
  }
}
</script>

<style scoped>

</style>